import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';
import colors from 'utils/colors';
import { PlainButton } from 'components/styled-components';

/*
 * This component takes the role from the currently logged in user and uses it as a key to
 * to determine which set of navigation links to render
 */

const Sidebar = ({ appUser }) => {
  const { role } = appUser;
  return (
    <Wrapper>
      {
        {
          // *** Admin ***
          ADMINISTRATOR: (
            <>
              <NavbarLink link="/" exact icon="dashboard" text="Dashboard" />
              <NavbarLink link="/assessments" icon="key" text="Assessments" />
              <NavbarLink
                link="/renewals"
                icon="calendar"
                text="Upcoming Renewals"
              />
              <NavbarLink
                link="/reports"
                icon="vertical-bar-chart-asc"
                text="Reports"
              />
              <NavbarLink
                link="/manage-questionnaires"
                icon="clipboard"
                text="Questionnaire Management"
              />
              <NavbarLink link="/users" icon="person" text="User Management" />
              <NavbarLink
                link="/manage-parties"
                icon="shop"
                text="Third Party Management"
              />
              <NavbarLink link="/admin-tools" icon="cog" text="Admin Tools" />
            </>
          ),
          // *** Limited Admin/Sponsor Admin ***
          LIMITED_ADMINISTRATOR: (
            <>
              <NavbarLink link="/" icon="dashboard" text="Dashboard" exact />
              <NavbarLink
                link="/assessments"
                icon="clipboard"
                text="Assessments"
              />
              <NavbarLink
                link="/renewals"
                icon="calendar"
                text="Upcoming Renewals"
              />
              <NavbarLink
                link="/reports"
                icon="vertical-bar-chart-asc"
                text="Reports"
              />
              <NavLink to="/new">
                <SideBarButton>
                  <NavIcon icon="add" className="btn-icon" iconSize={18} />
                  <span className="btn-text">Create Assessment</span>
                </SideBarButton>
              </NavLink>
            </>
          ),
		  DEPARTMENT_REVIEWER: (
			<>
			  	<NavbarLink link="/" icon="dashboard" text="Dashboard" exact />
				<NavbarLink
                	link="/assessments"
                	icon="clipboard"
                	text="Assessments"
        		/>
				<NavLink to="/new">
				  <SideBarButton>
					<NavIcon icon="add" className="btn-icon" iconSize={18} />
					<span className="btn-text">Create Assessment</span>
				  </SideBarButton>
				</NavLink>
			</>
		  ),
          // *** Sponsor ***
          SPONSOR: (
            <>
              <NavbarLink link="/" icon="dashboard" text="Dashboard" exact />
              <NavbarLink
                link="/assessments"
                icon="clipboard"
                text="Assessments"
              />
              <NavbarLink
                link="/renewals"
                icon="calendar"
                text="Upcoming Renewals"
              />
              <NavLink to="/new">
                <SideBarButton>
                  <NavIcon icon="add" className="btn-icon" iconSize={18} />
                  <span className="btn-text">Create Assessment</span>
                </SideBarButton>
              </NavLink>
            </>
          ),
          // *** Third Party ***
          THIRD_PARTY: (
            <>
              <NavbarLink link="/" icon="dashboard" text="Dashboard" exact />
              <NavbarLink
                link="/assessments"
                icon="clipboard"
                text="Assessments"
              />
              <NavbarLink
                link="/third-party-users"
                icon="person"
                text="User Management"
              />
            </>
          ),
        }[role]
      }
    </Wrapper>
  );
};

const NavbarLink = props => (
  <LinkWrapper to={props.link} {...props}>
    <NavIcon icon={props.icon} iconSize={18} />
    <Link {...props}>{props.text}</Link>
  </LinkWrapper>
);

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;

  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 1rem 0.6rem 0 0.6rem;
  height: 100%;
  min-width: 17rem;

  @media screen and (max-width: 1050px) {
    align-items: center;
    max-width: 5rem;
    min-width: 5rem;
    width: 100%;
  }
`;

const Link = styled.div`
  color: ${colors.darkGray};
  white-space: nowrap;

  @media screen and (max-width: 1050px) {
    display: none;
  }
  &:active {
    color: ${colors.white};
  }
`;

const NavIcon = styled(Icon)`
  margin-right: 0.8rem;

  @media screen and (max-width: 1050px) {
    margin: 1rem;
  }
`;

const LinkWrapper = styled(NavLink)`
  cursor: pointer;
  text-decoration: none !important;

  display: flex;
  padding: 1rem 0.7rem;
  font-size: 1rem;
  margin-bottom: 0.7rem;
  border-radius: 4px;
  align-items: center;

  -o-transition: 0.3s;
  -ms-transition: 0.3s;
  -moz-transition: 0.3s;
  -webkit-transition: 0.3s;
  /* ...and now for the proper property */
  transition: 0.3s;

  @media screen and (max-width: 1050px) {
    padding: 0;
    justify-content: center;
  }

  &:hover {
    background-color: ${colors.brandingPrimary};
  }

  &:hover ${NavIcon} {
    color: white;
  }

  &:hover ${Link} {
    color: white;
    fill: white;
  }

  &.active {
    background-color: ${colors.brandingPrimary};
  }

  &.active ${NavIcon} {
    color: white;
  }

  &.active ${Link} {
    color: white;
    fill: white;
  }
`;

const SideBarButton = styled(PlainButton)`
  margin: 0;

  .btn-icon {
    display: none;
    margin: 0;
  }

  @media screen and (max-width: 1050px) {
    .btn-text {
      display: none;
    }
    .btn-icon {
      display: flex;
    }
  }
`;

export default Sidebar;
